<template>
<div class="conquistas--block animation-top animation-delay-05">
  <div class="conquistas--block-button">
    <span class="conquistas"><h3>CONQUESTS</h3></span>
  </div>

  <div class="conquistas--block-icons">
    <slick ref="slick" :options="slickOptions" class="slick--unit__exercices" style="width: 100%!important">
      <div class="" v-for="(x, key) in conquistas" :key="x.id">
        <!-- <el-tooltip class="item" effect="dark" :content="x.name" placement="top" > -->
        <div class="conquistas--block-icons-box" :style="{background: x.color}" :class="{ block: !x.have}">
          <img :src="require('@/assets/img/conquistas/svg/' + x.id + '.svg')" rel="conquistas" alt="Minds">
        </div>
        <!-- </el-tooltip> -->
      </div>
    </slick>
  </div>

</div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  components: {
    Slick
  },
  name: 'buttonComponent',
  data() {
    return {
      slickOptions: {
        slidesToShow: 10,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        speed: 300,
        responsive: [{
          breakpoint: 1000,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 7
          }
        }, {
          breakpoint: 820,
          settings: {
            slidesToScroll: 6,
            slidesToShow: 6
          }
        }, {
          breakpoint: 700,
          settings: {
            slidesToScroll: 5,
            slidesToShow: 5
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        }]
      },
      conquistas: [{
        id: 1,
        name: 'Diamond',
        image: 'diamond',
        color: '#FF9900',
        have: false
      }, {
        id: 2,
        name: 'Baloon',
        image: 'text',
        color: '#0EB7BF',
        have: false
      }, {
        id: 3,
        name: 'Search',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 4,
        name: 'Clock',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 5,
        name: 'Paint',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 6,
        name: 'Rule',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 7,
        name: 'Magic',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 8,
        name: 'Computer',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 9,
        name: 'Money',
        image: 'star',
        color: '#ff4455',
        have: false
      }, {
        id: 10,
        name: 'Disk',
        image: 'star',
        color: '#ff4455',
        have: false
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/css/components/slick';

.conquistas--block {
    background: #F3F3F3;
    border-radius: 50px;
    height: 50px;
    display: flex;
    box-sizing: border-box;
    padding: 5px;
    justify-content: flex-start;
    align-items: center;
    box-shadow: 10px 22px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);
    width: 790px;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    .conquistas--block-icons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        width: 730px;
        max-width: 100%;
        margin: 0 auto;
        height: calc(100% + 10px);
        border-radius: 50px;
        position: relative;
        margin-left: 0!important;
        margin-right: 0!important;
        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: none;
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 20px;
        }
    }
    .conquistas--block-icons-box {
        display: flex!important;
        justify-content: center!important;
        align-items: center!important;
        img {
            width: 24px;
            height: 24px;
            transition: 0.1s;
            backface-visibility: visible;
            -webkit-perspective: 100;
            perspective: 1000;
        }
        width: 35px;
        height: 35px;
        max-width: 35px;
        border-radius: 50%;
        background: #ddd;
        margin-left: 11px;
        margin-right: 11px;
        transition: 0.1s;
        backface-visibility: visible;
        -webkit-perspective: 100;
        perspective: 1000;
        cursor: pointer;
        &:hover {
            transform: scale(1.1, 1.1);
            box-shadow: 10px 60px 40px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);
        }
    }
}

@media screen and (max-width: 1200px) {
    .conquistas--block-icons {
        margin-left: 35px !important;
        margin-right: 30px !important;
    }
}

.block {
    background: #AAAAAA!important;
    cursor: not-allowed!important;
    img {
        filter: grayscale(100%);
    }
    &:hover {
        transform: none!important;
    }
}

.conquistas--block-button {
    background: #D5D5D5;
    border-radius: 50px;
    color: #606060;
    width: 122px;
    padding-left: 5px;
    padding-right: 5px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    h3 {
        font-size: 13px!important;
        line-height: 12px!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/achievements/index.vue